// @flow
import TwitterCard from 'components/social/TwitterCard';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/social/TwitterCard';

export default connect(
  (state: StateType): StateProps => ({
    twitter_lien: state.settingsState.liens_rs.twitter_lien,
  })
)(TwitterCard);
